import gql from 'graphql-tag';

const singlePatternFragment = gql`
    fragment SinglePatternFragment on PatternNode {
        id
        name
        altName
        patternClass
        slug
        code
        business
    }
`;

export default singlePatternFragment;